import { render, staticRenderFns } from "./gradientColor.vue?vue&type=template&id=5d5228b8&"
import script from "./gradientColor.vue?vue&type=script&lang=js&"
export * from "./gradientColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports